import { render } from "./students_barcodes.vue?vue&type=template&id=27ca085d&scoped=true"
import script from "./students_barcodes.vue?vue&type=script&lang=js"
export * from "./students_barcodes.vue?vue&type=script&lang=js"

import "./students_barcodes.vue?vue&type=style&index=0&id=27ca085d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ca085d"]])

export default __exports__